export default "__VITE_ASSET__DZe0kUiB__"